<template>
  <div id="partner" class="sec">
    <v-container>
      <v-row justify="center">
        <div
          class="head"
          data-aos="fade-up"
          :class="MIXIN_SETUP_UI.header"
        >
          Be a Partner
        </div>
      </v-row>
      <v-card
        rounded="lg"
        flat
        data-aos="fade-up"
        :class="MIXIN_SETUP_UI.defaultSideMargin"
      >
        <v-form ref="partnerForm">
          <v-row>
            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              :style="{ padding: $vuetify.breakpoint.smAndDown ? '40px' : '100px 40px 100px 150px' }"
            >
              <!-- Name -->
							<v-text-field
								label="Name*"
								type="text"
								ref="Name"
								v-model="name"
								:rules="[() => !!name || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Email Address -->
              <v-text-field
								label="Email Address*"
								type="text"
								ref="emailAddress"
								v-model="emailAddress"
								:rules="[() => !!emailAddress || 'This field is required',
												 () => /.+@.+\..+/.test(emailAddress) || 'Email must be valid']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Designation -->
              <v-text-field
								label="Designation*"
								type="text"
								ref="designation"
								v-model="designation"
								:rules="[() => !!designation || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Company Name -->
              <v-text-field
								label="Company Name*"
								type="text"
								ref="companyName"
								v-model="companyName"
								:rules="[() => !!companyName || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Contact Number -->
              <v-text-field
								label="Contact Number*"
								type="text"
								ref="contactNumber"
								v-model="contactNumber"
								:rules="[() => !!contactNumber || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Website -->
              <v-text-field
								label="Website*"
								type="text"
								ref="website"
								v-model="website"
								:rules="[() => !!website || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>
            </v-col>

            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              :style="{ padding: $vuetify.breakpoint.smAndDown ? '40px' : '100px 150px 100px 40px' }"
            >
              <!-- Requirements -->
              <v-textarea
                label="Brief company requirements"
                auto-grow
                ref="requirements"
                v-model="requirements"
                :rules="[() => !!requirements || 'This field is required']"
                :error-messages="errorMessages"
              ></v-textarea>
            
              <!-- Submit button -->
              <v-row justify="end" class="text-right">
                <v-col cols="6">
                  <base-button
                    name="Send"
                    color="#0e6ccd"
                    x-large
                    block
                    @click="confirmPartnerInfo()"
                  ></base-button>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>

    <base-confirm-dialog
			v-model="confirmDialog"
			title="Continue"
			message="Would you like to be our partner?"
			@do="savePartnerInfo()"
		></base-confirm-dialog>

		<base-success-dialog
			v-model="successDialog"
			title="Thank you!"
			message="You successfully submitted your partnership request."
		></base-success-dialog>
  </div>
</template>

<script>
  import Repository from "@/api/repositories";
  const FormEmailApi = Repository.get("formEmails");

  export default {
    name: "PartnerSection",

    data: () => ({
      /* form fields */
			name: null,
			designation: null,
			emailAddress: null,
			contactNumber: null,
      companyName: null,
      website: null,
			businessNature: null,
      employeesTotal: null,
      respondentsTotal: null,
      budget: null,
      provider: null,
      requirements: null,
			/* form fields */
			errorMessages: '',
			confirmDialog: false,
      successDialog: false,
      totals: [
        "Below 10",
        "11-50",
        "51-200",
        "201-500",
        "501-1,000",
        "1,001-5,000",
        "Above 5,000"
      ],
      budgets: [
        "Below 20,000",
        "100,000-200,000",
        "200,000-700,000",
        "Above 700,000"
      ]
    }),

    computed: {
      partnerForm() {
        return {
          name: this.name,
          emailAddress: this.emailAddress,
          designation: this.designation,
          companyName: this.companyName,
          website: this.website,
          contactNumber: this.contactNumber,
          requirements: this.requirements,
        }
      },
    },

    methods: {
      confirmPartnerInfo() {
        if (this.$refs.partnerForm.validate()) this.confirmDialog = true;
      },
      async savePartnerInfo() {
        this.confirmDialog = false;

        try {
           /**
            * key = partner because request is coming from partner form
            */
          let key = "partner";
          let form = {
            key,
            data: JSON.stringify(this.partnerForm),
            ...this.partnerForm
          };

          let save = await FormEmailApi.createViaKey(key, form);

          if (save) {
            this.successDialog = true;
          }
          else {
            console.log("Sorry, there was a problem saving your transaction.");
          }
        }
        catch(error) {
          console.log(error);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.box {
  padding: 80px;
}
</style>